<template>
  <v-app-bar
    height="106"
    elevation="0"
    class="px-4"
  >
    <v-card
      width="100%"
      height="86"
      rounded="lg"
      class="register-app-bar d-flex align-center px-6"
    >
      <img :src="require('@/assets/logo.svg')" alt="monitait" :width="$store.state.desktop ? '187' : '120'">
      <v-spacer />
      <v-sheet color="transparent">
        <v-select
          lable="language"
          :items="langs"
          density="compact"
          variant="text"
          :model-value="lang"
          @update:model-value="changeLang"
          class="text-white"
          hide-details
        ></v-select>
      </v-sheet>
    </v-card>
  </v-app-bar>
</template>

<script>
import { languages, defaultLocale } from '@/locales'

export default {
  name: "RegisterAppbar",
  data: () => ({
    lang: null,
  }),
  computed: {
    langs() {
      return Object.keys(languages)
    }
  },
  beforeMount() {
    this.lang = localStorage.getItem('lang') || defaultLocale
  },
  methods: {
    changeLang(event) {
      localStorage.setItem('lang', event)
      if (this.lang !== event) {
        this.$router.go()
      }
    }
  }
}
</script>

<style>
.register-app-bar {
  background: radial-gradient(151.88% 64.7% at 0% 35.3%, rgba(83, 83, 83, 0.64) 0.55%, rgba(0, 0, 0, 0.64) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */, #354764 !important;
}
</style>
